import { h as __h } from "preact";
/** @import { adminMemberResponse } from "~/backend/validate.js"; */
import { ApiError, authedApiRequest } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ orgId: string; groupId: string }} props
 * @param {adminMemberResponse[]} members
 */
export const removeMembers = async ({
  orgId,
  groupId
}, ...members) => {
  const res = await confirmModal({
    title: members.length === 1 ? `Remove ${members[0]?.name} from this group?` : `Remove ${members.length} members from this group?`,
    action: "Remove",
    body: __h("p", {}, "They will still be members of the organization.")
  });
  if (!res) return;
  try {
    await authedApiRequest("DELETE", `/v2/orgs/${orgId}/groups/${groupId}/members`, {
      json: {
        user_ids: members.map(member => member.id)
      }
    });
    Query.invalidate([`/v2/orgs/${orgId}/groups`], [`/v2/orgs/${orgId}/groups/${groupId}`], [`/ui/admin/orgs/${orgId}/members`], ...members.map(member => [`/ui/admin/orgs/${orgId}/members/${member.id}`]));
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};